var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isLeaved
    ? _c(
        "div",
        { staticClass: "modal-cover", on: { click: _vm.onClose } },
        [
          _c(
            "div",
            {
              staticClass: "participant-container",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("div", { staticClass: "participant-header-container" }, [
                _c("button", {
                  staticClass: "close-modal",
                  on: { click: _vm.onClose },
                }),
                _c("div", [
                  _vm._v(_vm._s(_vm.$t("camstudy.participant.title"))),
                ]),
                _c("div", {
                  staticClass: "participant-invite-icon",
                  on: { click: _vm.openInviteModal },
                }),
              ]),
              _c(
                "ul",
                { staticClass: "participant-body-container overflow-y-scroll" },
                _vm._l(_vm.filteredParticipants, function (participant) {
                  return _c(
                    "li",
                    {
                      key: participant.id,
                      staticClass: "participant-user-item",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex w-full overflow-hidden mr-3 items-center user-item-img-name",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "v-name-img" },
                            [
                              _c("UserProfileImage", {
                                attrs: { "user-id": participant.userId },
                              }),
                              _vm.hasEmceeRole(participant.userId)
                                ? _c("GrmIcon", {
                                    class: _vm.hasSpeakerRole(
                                      participant.userId
                                    )
                                      ? "room-speaker"
                                      : "room-emcee",
                                    attrs: { icon: "" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "v-name-determine" }, [
                            _c("div", { staticClass: "user-name" }, [
                              _vm._v(
                                _vm._s(participant.nickname) +
                                  _vm._s(
                                    _vm.isMe(participant.userId)
                                      ? _vm.$t("camstudy.participant.me")
                                      : ""
                                  )
                              ),
                            ]),
                            _c("div", { staticClass: "user-msg" }, [
                              _vm._v(_vm._s(_vm.userMsg(participant.userId))),
                            ]),
                          ]),
                        ]
                      ),
                      !_vm.isMe(participant.userId)
                        ? _c(
                            "div",
                            { staticClass: "flex gap-2 flex-shrink-0" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center justify-center",
                                  on: {
                                    click: function ($event) {
                                      _vm.blockUserScreen({
                                        userId: participant.userId,
                                        block: !_vm.isUserScreenBlock(
                                          participant.userId
                                        ),
                                      })
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "screen-block",
                                      class: {
                                        block: _vm.isUserScreenBlock(
                                          participant.userId
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isUserScreenBlock(
                                            participant.userId
                                          )
                                            ? _vm.$t(
                                                "camstudy.participant.unblockScreen"
                                              )
                                            : _vm.$t(
                                                "camstudy.participant.blockScreen"
                                              )
                                        ) + " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm.hasEmceeRole() &&
                              !_vm.hasSpeakerRole(participant)
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex items-center justify-center",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openSelectKickOrBanUser(
                                            participant
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "button",
                                        { staticClass: "exit-user" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "camstudy.participant.exit"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hasEmceeRole()
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "permission-user",
                                      class: {
                                        active:
                                          _vm.selectedAciveUser ===
                                          participant.userId,
                                      },
                                      on: {
                                        click: () =>
                                          _vm.toggleUserPermission(participant),
                                      },
                                    },
                                    [
                                      _vm.selectedAciveUser ===
                                      participant.userId
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "permission-modal-cover",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "permission-modal",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "permission-item",
                                                      attrs: {
                                                        disabled:
                                                          !_vm.enableChangeRole(
                                                            "speaker"
                                                          ),
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.setRoleId(
                                                            _vm.currentUser,
                                                            "speaker"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "camstudy.participant.role.changeToSpeaker"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "permission-item",
                                                      attrs: {
                                                        disabled:
                                                          !_vm.enableChangeRole(
                                                            "emcee"
                                                          ),
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.setRoleId(
                                                            _vm.currentUser,
                                                            "emcee"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "camstudy.participant.role.changeToEmcee"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "permission-item",
                                                      attrs: {
                                                        disabled:
                                                          !_vm.enableChangeRole(
                                                            "participant"
                                                          ),
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.setRoleId(
                                                            _vm.currentUser,
                                                            "participant"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "camstudy.participant.role.changeToParticipant"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
              _vm.isMobile && _vm.isOpenKickOrBanUser
                ? _c("KickOrBanUser", {
                    attrs: { user: _vm.selectedUser },
                    on: {
                      close: () => {
                        _vm.isOpenKickOrBanUser = false
                        _vm.selectedUser = {}
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          !_vm.isMobile && _vm.isOpenKickOrBanUser
            ? _c("KickOrBanUser", {
                attrs: { user: _vm.selectedUser },
                on: {
                  close: () => {
                    _vm.isOpenKickOrBanUser = false
                    _vm.selectedUser = {}
                  },
                },
              })
            : _vm._e(),
          _vm.isOpenInviteModal
            ? _c(
                "div",
                {
                  staticClass: "invite-container",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c("div", { staticClass: "invite-header-container" }, [
                    _c("div", [
                      _vm._v(_vm._s(_vm.$t("camstudy.invite.title"))),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "invite-body-container overflow-y-scroll" },
                    [
                      _c("div", { staticClass: "pt-3" }, [
                        _c(
                          "div",
                          { staticClass: "flex justify-between mb-3" },
                          [
                            _c("div", { staticClass: "invite-email-title" }, [
                              _vm._v(
                                _vm._s(_vm.$t("camstudy.invite.emailToInvite"))
                              ),
                            ]),
                            _c("div", { staticClass: "invite-email-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("camstudy.invite.onlyRegisteredEmails")
                                )
                              ),
                            ]),
                          ]
                        ),
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticClass: "invite-email-input-container",
                              class: { wrong: _vm.isWrongEmailValidation },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.inviteInputData,
                                    expression: "inviteInputData",
                                  },
                                ],
                                staticClass: "invite-input",
                                attrs: { type: "text" },
                                domProps: { value: _vm.inviteInputData },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.inviteInputData = $event.target.value
                                  },
                                },
                              }),
                              _c(
                                "div",
                                { staticClass: "invite-button-container" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "invite-button",
                                      on: { click: _vm.onAddInviteUser },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("camstudy.invite.add"))
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm.isWrongEmailValidation
                            ? _c("div", { staticClass: "wrong-email" }, [
                                _vm._v(_vm._s(_vm.wrongMessage)),
                              ])
                            : _vm._e(),
                        ]),
                        _c(
                          "div",
                          { staticClass: "invite-user-list-container" },
                          [
                            _c("div", { staticClass: "invite-user-title" }, [
                              _vm._v(
                                _vm._s(_vm.$t("camstudy.invite.inviteeList")) +
                                  " "
                              ),
                              _c("span", { staticClass: "invite-user-count" }, [
                                _vm._v(_vm._s(_vm.getInviteUserListLength)),
                              ]),
                            ]),
                            _c(
                              "ul",
                              { staticClass: "invite-user-list" },
                              _vm._l(_vm.inviteUserList, function (email) {
                                return _c(
                                  "li",
                                  { key: email, staticClass: "invite-user" },
                                  [
                                    _c("div", { staticClass: "email" }, [
                                      _vm._v(_vm._s(email)),
                                    ]),
                                    _c("button", {
                                      staticClass: "remove-email",
                                      attrs: { value: email },
                                      on: { click: _vm.onRemoveEmail },
                                    }),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "invite-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "invite-footer-button cancel",
                        on: { click: _vm.onCloseInviteModal },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "invite-footer-button save",
                        on: { click: _vm.onInviteUser },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("camstudy.invite.invitePeople", {
                              count: _vm.getInviteUserListLength,
                            })
                          )
                        ),
                      ]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }